import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/telegram-plane': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M446.7 98.6L379.1 417.4C374 439.9 360.7 445.5 341.8 434.9L238.8 359 189.1 406.8C183.6 412.3 179 416.9 168.4 416.9L175.8 312 366.7 139.5C375 132.1 364.9 128 353.8 135.4L117.8 284 16.2 252.2C-5.9 245.3-6.3 230.1 20.8 219.5L418.2 66.4C436.6 59.5 452.7 70.5 446.7 98.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/telegram-plane.js
// module id = QdYV
// module chunks = 144